<template>
  <div>
    <button @click="showAssessmentModal()" class="px-6 py-2 border rounded cursor-pointer bg-gray-100 text-gray-500">
      View Criteria
    </button>
    <pl-dialog v-if="isAssessmentModalOpen === true" @close="isAssessmentModalOpen = false" :size="'md'">
      <div v-if="criteriaScale > 0" class="pl-subheading start-xs">
        Max Score: {{ criteriaScale }}
      </div>
      <div class="row col-xs start-xs overflow-auto" style="padding: 10px 20px">
        <div class="col-xs-6 start-xs p-3" v-for="(point, index) in rewards" :key="index">
          <span class="pl-title">
            {{ point.title }}
          </span>
          <div class="pl-body-2 row col-xs start-xs middle-xs">
            <p>{{ typeof point.description === 'object' ? point.description.join('. ') : point.description }}</p>
          </div>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  export default Vue.extend({
    data() {
      return {
        isAssessmentModalOpen: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'summaryOverlayOpened']),
      submissionPage: function() {
        return this.$route.name === 'roundtable.submit';
      },
      fullReportPage: function() {
        return this.$route.name === 'course.student-summary';
      },
      liveDiscussionPage: function() {
        return this.$route.name === 'live-discussion.index';
      },
    },
    props: {
      rewards: {
        type: Array,
        default: []
      },
      criteriaScale: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      showAssessmentModal: function() {
        this.isAssessmentModalOpen = true;
      },
    },
  });
</script>



// WEBPACK FOOTER //
// pointDescriptions.vue?25097cd2